import { forwardRef, type Ref, type SVGProps } from "react";
const IconFloorPlanOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M4 30h3a1 1 0 0 0 0-2H4V15h10v2a1 1 0 0 0 2 0V8a1 1 0 0 0-2 0v5H4V4h24v9h-7a1 1 0 0 0 0 2h7v13H16v-5h3a1 1 0 0 0 0-2h-4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2" /></svg>;
const ForwardRef = forwardRef(IconFloorPlanOutlineSVG);
ForwardRef.displayName = "IconFloorPlanOutline";
export { ForwardRef as IconFloorPlanOutline };